import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import { API } from "@/lib/api";

export default function CancelAppointment() {
  const { aid, token } = useParams();
  const [state, setState] = useState({ loading: true, ok: false, msg: "" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const res = await fetch(`${API}/appointments/${aid}/cancel-link/${token}`, { method: "POST" });
        const data = await res.json().catch(() => ({}));
        if (res.ok) {
          setState({
            loading: false, ok: true,
            msg: data.already
              ? "Bu randevu zaten iptal edilmişti."
              : "Randevun başarıyla iptal edildi. Ders hakkın paketine iade edildi.",
          });
        } else {
          setState({ loading: false, ok: false, msg: data.detail || "Bağlantı geçersiz veya randevu bulunamadı." });
        }
      } catch {
        setState({ loading: false, ok: false, msg: "Bir hata oluştu. Lütfen daha sonra tekrar dene." });
      }
    })();
  }, [aid, token]);

  return (
    <div className="min-h-screen bg-[#0B0B0E] flex flex-col items-center justify-center p-6" data-testid="cancel-appointment-page">
      <div className="mb-8"><Logo /></div>
      <div className="w-full max-w-sm rounded-2xl border border-[#222230] bg-[#13131C] p-8 text-center">
        {state.loading ? (
          <>
            <Loader2 className="animate-spin mx-auto text-[#FF5500] mb-3" size={36} />
            <p className="text-sm text-[#A0A0B2]">Randevun iptal ediliyor...</p>
          </>
        ) : state.ok ? (
          <>
            <CheckCircle2 className="mx-auto text-[#10B981] mb-3" size={44} />
            <h1 className="font-display text-xl font-bold text-white mb-2">İptal Edildi</h1>
            <p className="text-sm text-[#A0A0B2]" data-testid="cancel-result-message">{state.msg}</p>
          </>
        ) : (
          <>
            <XCircle className="mx-auto text-[#EF4444] mb-3" size={44} />
            <h1 className="font-display text-xl font-bold text-white mb-2">İptal Edilemedi</h1>
            <p className="text-sm text-[#A0A0B2]" data-testid="cancel-result-message">{state.msg}</p>
          </>
        )}
      </div>
      <Link to="/login" className="mt-6 text-sm text-[#FF5500] hover:underline" data-testid="cancel-login-link">
        Uygulamaya giriş yap →
      </Link>
    </div>
  );
}
